import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "none" }, [
      _createElementVNode("path", {
        fill: "#39579A",
        d: "M33.5 35c.8 0 1.5-.7 1.5-1.5v-32c0-.8-.7-1.5-1.5-1.5h-32C.7 0 0 .7 0 1.5v32c0 .8.7 1.5 1.5 1.5z"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M18.9 35V21H14v-5.1h4.9V12c0-4.5 2.8-7 6.9-7 2 0 3.7.1 4.2.2V10h-2.9c-2.2 0-2.6 1-2.6 2.6v3.3h5.2l-.8 5.1h-4.4v14z"
      })
    ], -1)
  ])))
}
export default { render: render }